<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><span class="blue">Dedication</span></h2>
<p class="para"><em>To my students:</em></p>
<p class="para1">Their work inspires me with its creativity and originality. It is from them that I continue to learn new, improved methods and techniques to add to my repertoire, as well as gain an ever-increasing community of quilting friends.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?28f7204e